import styles from './_sortByLetter.module.scss'
import classnames from 'classnames'
import Scrollspy from 'react-scrollspy'
import { useEffect, useRef } from 'react'

interface SortByLetterProps {
  items: string[]
  reversed: boolean
}

const SortByLetter: React.FC<SortByLetterProps> = ({ items, reversed }) => {
  const getElem = (letter) => document.querySelector(`#letter-${letter}`)

  const goToSmooth = (letter) => {
    getElem(letter)?.scrollIntoView({
      behavior: 'smooth'
    })
  }

  const abc = 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(',')
  const letters = reversed ? abc.reverse() : abc
  const existLetters = Array.from(new Set(items.map((el) => el.charAt(0))))
  const letterIntervals = useRef({})

  const toucheMoveHandler = (e) => {
    if (e) {
      const currentPosition = e.changedTouches[0].clientY
      letters.forEach((el) => {
        const currentInterval = letterIntervals.current[el]
        if (
          currentPosition > currentInterval[0] &&
          currentPosition < currentInterval[1]
        ) {
          goToSmooth(el)
        }
      })
    }
  }

  const renderedLetters = letters.map((el, id) => {
    if (existLetters.includes(el)) {
      return (
        <div
          key={id}
          className={classnames('nav-letter', styles.sortLetter, {
            [styles.isActive]: id === 1
          })}
          onClick={() => goToSmooth(el)}
          onTouchMove={toucheMoveHandler}
        >
          {el}
        </div>
      )
    } else {
      return (
        <div
          key={id}
          className={classnames(
            'nav-letter',
            styles.isDisabled,
            styles.sortLetter,
            {
              [styles.isActive]: id === 1
            }
          )}
        >
          {el}
        </div>
      )
    }
  })

  useEffect(() => {
    const lettersNodeArray = document.querySelectorAll('.nav-letter')
    lettersNodeArray.forEach((node) => {
      const viewportOffset = node.getBoundingClientRect()
      letterIntervals.current[node.textContent] = [
        viewportOffset.top,
        viewportOffset.bottom
      ]
    })
    getElem(letters[0])?.scrollIntoView(true)
    window.scrollTo({ top: 0 })
  }, [])

  return (
    <Scrollspy
      items={abc.map((el) => `letter-${el}`)}
      currentClassName={styles.isCurrent}
      componentTag={'div'}
      className={classnames(styles.sortByLetter, 'is-flex-tablet')}
    >
      {renderedLetters}
    </Scrollspy>
  )
}

export default SortByLetter
